<div class="chatbot-container">
  <!-- <div class="chat-header">
    <h3>AI ChatBot</h3>
  </div> -->
  <div class="chat-body"  #chatBody id="chatBody">
    <div *ngFor="let msg of messages" [ngClass]="{'user-msg': msg.sender === 'user', 'bot-msg': msg.sender === 'bot'}">
      <span [innerHTML]="formatOpenAIMessage(msg.text)"></span>
    </div>
    <div class="typing" *ngIf="isThinking">
      <i class="pi pi-ellipsis-h"></i> Agent is thinking...
    </div>
  </div>
  <div class="chat-footer">
    <form (ngSubmit)="sendMessage(null)" style="width:100%;display:flex;gap:0.5rem;">
      <textarea [(ngModel)]="userInput" name="userInput" placeholder="Type your message..." pTextarea autocomplete="off"
       (keydown.enter)="sendMessage($event)"></textarea>
      <button pButton type="submit" icon="pi pi-send" label="Send" [disabled]="!userInput" [loading]="isThinking"></button>
    </form>
  </div>
</div>
